<template>
<!-- 求职者信息 -->
    <div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="姓名" width="130"></el-table-column>
            <!-- <el-table-column prop="phone" label="手机号码"></el-table-column> -->
            <el-table-column prop="sex" label="性别" width="100">
                <template slot-scope="scope" >
                    <el-tag v-if="scope.row.sex == 1">男</el-tag>
                    <el-tag type="danger" v-else>女</el-tag>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="birthday" label="出生日期"></el-table-column>  -->
            <!-- <el-table-column prop="docNumber" label="证件号码" width="200"></el-table-column> -->
            <!-- <el-table-column prop="currAddr" label="现居地址" ></el-table-column> -->
            <el-table-column prop="jobName" label="岗位名称" width="120"></el-table-column>
            <!-- <el-table-column prop="docName" label="证件类型" ></el-table-column> -->
            <!-- <el-table-column prop="email" label="邮箱" ></el-table-column> -->
            <!-- <el-table-column prop="ethnic" label="民族"></el-table-column> -->
            <el-table-column prop="resumeUrl" label="简历地址">
                <template slot-scope="scope" >
                    <a :href="scope.row.resumeUrl" style="color:blue;" target="_black">{{scope.row.resumeUrl}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="expectedSalaryMax" label="最高期望月薪" width="120"></el-table-column>
            <el-table-column prop="expectedSalaryMin" label="最低期望月薪" width="120"></el-table-column>
            
            <el-table-column label="操作" width="120">
                <template slot-scope="scope" >
                    <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deleteJobWantedInfo(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="sizes, prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// listJobSeeker      查询求职者
// deleteJobSeeker    删除求职者
// getListJoinUs        招聘信息
// getListDocType   证件类型
import { 
listJobSeeker,
deleteJobSeeker,
getListJoinUs,
getListDocType,} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteJobWantedInfo',

    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            count:0,
            // 求职者
            tableData: [],
            title:'',
            dialogFormVisible:false,
            // 要修改或者要增加
            operObj:{
                coverImageUrl:'',
                introduce:'',
                newsContent:'',
                newsDate:'',
                title:'',
                views:'',
                id:'',
            },
            // 职位列表
            joinUsList:[],
            // 证件类型
            docTypeList:[]
        };
    },

    mounted() {
        
    },
    watch:{
        docTypeList(){
            this.selectJobWantedInfo()
        }
    },
    methods: {
        // 查询职位列表 和证件类型
        async selectListJoinUs(){
            let res = await getListJoinUs()
            this.joinUsList = res.data
            let dtype = await getListDocType()
            this.docTypeList = dtype.data
        },
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectJobWantedInfo()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectJobWantedInfo()
        },
        // 查询求职者列表
        async selectJobWantedInfo(){
            let res = await listJobSeeker({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            res.data.forEach(item1 => {
                this.joinUsList.forEach(item2 => {
                    if(item1.jobId == item2.id){
                        item1.jobName = item2.jobTitle
                    }
                })
                this.docTypeList.forEach(item2 => {
                    if(item1.docType == item2.id){
                        item1.docName = item2.name
                    }
                })
            })
            // 学历信息
            this.count = res.page.count
            this.tableData = res.data
        },
        // 删除
        async deleteJobWantedInfo(id){
            let res = await deleteJobSeeker(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectJobWantedInfo()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectListJoinUs()
    }
};
</script>

<style lang="scss">
.personalInfo .recruit{
    .el-form-item__label{
        width: 120px !important;
    }

}
</style>
<style lang="scss" scoped>
// 分页
.pagination{
    padding: 50px 270px 30px 270px;
    text-align: center;
}
</style>